import { Stack } from "expo-router";

/**
 * Chat stack layout
 */
export default function ChatLayout() {
  return (
    <Stack
      screenOptions={{
        headerShown: false,
      }}
    />
  );
}

